
import { TerritoryViolation } from '@/config/types';
import Card from '@/components/Card/index.vue';
import Input from '@/components/InputWithValidation/index.vue';
import { FormatDateFilter } from '@/utils/filters';
import Vue from 'vue';
import { Main } from './styles';

export default Vue.extend({
  name: 'PenaltyCard',
  components: {
    Card,
    Main,
    Input,
  },
  filters: {
    FormatDateFilter,
  },
  data() {
    return {
      showDetails: false,
    };
  },
  methods: {
    open() {
      this.showDetails = !this.showDetails;
      console.log('chegou', this.showDetails);
    },
  },
  props: {
    territoryViolation: {
      type: Object as () => TerritoryViolation,
    },
  },
});
